import styles from './LoadingOverlay.module.scss';

export function LoadingOverlay() {
  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
    </div>
  );
}
